import { Outlet } from "react-router";

import { Footer } from "@/client/components/public/footer";
import { NavBar } from "@/client/components/public/nav-bar";

// Note: do NOT wrap this in Radix UI's <ScrollArea>. Its Viewport uses
// display: table + min-width: 100%, which lets content size to its
// intrinsic max width and break mobile layout (produced a 1963px-wide
// main on a 390px viewport). Native browser scroll is correct for
// public marketing + docs pages.
//
// Chrome (NavBar + Footer) is owned by this layout — page components
// must NOT render their own copies, or the public site will show
// duplicate <header>/<footer> elements stacked.
export const HomeLayout = () => (
  <div className="flex min-h-screen flex-col">
    <NavBar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);
